import { IUserAccepted } from '../../../actions/userAccount/user/fetchUser'
import { IUserAccountStore } from '../index'

export default function(
  state: IUserAccountStore,
  action: IUserAccepted,
): IUserAccountStore {
  return {
    ...state,
    request: {
      ...state.request,
      errMessage: '',
      isLoading: false,
    },
    user: { ...state.user, ...action.user },
  }
}
